import { RequestData } from '@ant-design/pro-table';
import { normalizeEmailFields } from '@/utils/email';
import { request } from '@/utils/request';

export interface UsersListItem {
  signupDate: Date;
  id: string;
  name: string;
  status: string;
  accountNumber: string;
  relationshipManager: {
    id: string;
    name: string;
  };
  vendor: {
    id: number;
    name: string;
  };
  email: string;
  phone: string;
  countryCode: number;
}

export enum AccountType {
  PERSONAL = 'PERSONAL',
  CORPORATE = 'CORPORATE',
  COBRAND = 'COBRAND',
  OPERATION = 'OPERATION'
}

export const AccountTypeLabel: Record<AccountType, string> = {
  [AccountType.PERSONAL]: 'Personal',
  [AccountType.CORPORATE]: 'Corporate',
  [AccountType.COBRAND]: 'CoBrand',
  [AccountType.OPERATION]: 'Operation'
};

export interface JwtToken {
  id: string;
  iat: number;
  exp: number;
}

export interface SolutionApplicationFile {
  fileList: Array<{ uid?: string; name?: string; url?: string; status?: string; response?: { url?: string } }>;
}

export interface ClientDocumentDetail {
  id: string;
  name?: string;
  fileName?: string;
  documentKey?: string;
  documentUrl?: string;
}

export interface ClientDocument {
  id?: string;
  documentType?: string;
  status?: string;
  details?: Array<ClientDocumentDetail>;
}

export async function queryMyRoutes() {
  return request<any>('/~/routes');
}

export async function query(params: any): Promise<RequestData<UsersListItem>> {
  const normalizedParams = normalizeEmailFields(params, ['email']);
  if (normalizedParams.signupDate) {
    normalizedParams.fromDate = normalizedParams.signupDate[0];
    normalizedParams.toDate = normalizedParams.signupDate[1];
    delete normalizedParams.signupDate;
  }
  return request<RequestData<UsersListItem>>('/users', { params: normalizedParams });
}

export async function queryAccountActivation(params: any): Promise<RequestData<UsersListItem>> {
  const normalizedParams = normalizeEmailFields(params, ['email']);
  if (normalizedParams.signupDate) {
    normalizedParams.fromDate = normalizedParams.signupDate[0];
    normalizedParams.toDate = normalizedParams.signupDate[1];
    delete normalizedParams.signupDate;
  }
  normalizedParams.status = 'PENDING_ACTIVATION';
  const usersListItem = await request<RequestData<UsersListItem>>('/users', { params: normalizedParams });
  return usersListItem;
}
